























































































































































































































































































































import { startCase } from 'lodash';
import { PropType } from 'vue';
import moment from 'moment';
import {
  EmployeeHourlySubType,
  IEmployee,
  IEmployeeTimeOffBookingBalance,
  ITimeOffRequest,
  ITimeOffAttachment,
  ITimeOffTypeData,
  IUserData,
  TimeOffStateEnum,
  TimeOffRequestAmountTypes
} from '@/models';

import ErrorAlert from '../common/ErrorAlert.vue';
import TimeOffRequestDetailMenuCardStateActionButtons from './TimeOffRequestDetailMenuCardStateActionButtons.vue';
import TimeOffApproverList from './TimeOffApproverList.vue';
import TimeOffBookingBalanceCardDetail from './TimeOffBookingBalanceCardDetail.vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';

import mixins from '@/utils/mixins';
import SnackbarMixin from '@/mixins/snackbar';
import authMixin from '@/mixins/auth';

import { createFile } from '@/utils/helpers';
import { PartialOptions } from './TimeOffRequestDetailFormDialog.vue';
import TimeOffRequestCommentList from './TimeOffRequestCommentList.vue';

export default mixins(SnackbarMixin, authMixin).extend({
  name: 'TimeOffRequestDetailMenuCard',

  components: {
    TimeOffRequestDetailMenuCardStateActionButtons,
    ErrorAlert,
    TimeOffApproverList,
    TimeOffBookingBalanceCardDetail,
    TimeOffRequestCommentList
  },
  props: {
    event: {
      type: Object as PropType<ITimeOffRequest>
    },
    tableView: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      TimeOffRequestAmountTypes,
      TimeOffStateEnum,
      errorMessage: '',
      errorMessageDetail: '',

      hasError: false,
      EmployeeHourlySubType,

      bookingBalanceRules: [
        (v: number) => {
          return v >= 0 || 'Booking balance exceeds available entitlement';
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      employeeTimeOffBalances: 'employeeTimeOff/getEmployeeTimeOffBalances'
    }),

    isCalendarHoliday(): boolean {
      return (
        this.event.state == TimeOffStateEnum.PaidHoliday ||
        this.event.state == TimeOffStateEnum.UnpaidHoliday
      );
    },

    isOverBalance(): boolean {
      const balance = this.employeeTimeOffBalances.find(
        (data: IEmployeeTimeOffBookingBalance) =>
          (data.employee_entitlement?.timeoff as ITimeOffTypeData).id ==
          (this.event.type! as ITimeOffTypeData).id
      );

      return balance?.remaining_balance < 0;
    },

    canEdit(): boolean {
      let canEdit = false;
      if (this.isTimeOffOwner || this.isTimeOffEmployee) {
        canEdit =
          this.event.state == TimeOffStateEnum.Draft ||
          this.event.state == TimeOffStateEnum.Submitted ||
          (moment(this.event.start).isSameOrAfter(moment().utc(true)) &&
            this.event.state == TimeOffStateEnum.Approved);
      }
      if (
        this.isTimeOffApprover ||
        this.isUserHRPersonnel ||
        this.isUserRoleSupervisorAndTimeOffEmployeeHourly
      ) {
        canEdit = this.isEditableState;
      }

      return canEdit;
    },

    canViewAdvancedDetail(): boolean {
      return (
        this.userHasRoles(['HR Personnel']) ||
        this.isUserRoleSupervisorAndTimeOffEmployeeHourly ||
        this.isTimeOffOwner ||
        this.isTimeOffApprover ||
        this.isTimeOffEmployeeSupervisor ||
        this.isTimeOffEmployee
      );
    },

    canViewBookingBalance(): boolean {
      return (
        this.event && !this.isCalendarHoliday && this.canViewAdvancedDetail
      );
    },

    canManageComments(): boolean {
      return (
        !this.isCalendarHoliday &&
        this.event.state !== TimeOffStateEnum.Submitted &&
        this.canViewAdvancedDetail
      );
    },

    isEditableState(): boolean {
      switch (this.event.state) {
        case TimeOffStateEnum.Rejected:
        case TimeOffStateEnum.Cancelled:
          return false;
        default:
          return true;
      }
    },

    isTimeOffOwner(): boolean {
      return this.getCurrentUserFullName == this.event.owner;
    },

    isTimeOffEmployee(): boolean {
      return (
        this.currentUser.employee == (this.event.employee as IEmployee)?.id
      );
    },

    isTimeOffEmployeeSupervisor(): boolean {
      return (
        this.currentUser.employee ==
        ((this.event.employee as IEmployee)!.supervisor as IEmployee)?.id
      );
    },

    isTimeOffApprover(): boolean {
      return this.event
        .approvers!.map(approver => (approver.approver as IUserData).id)
        .includes(this.currentUser.id);
    },

    /** If the timeoff employee is hourly and the current user is a `supervisor` group then allow access for appropiate state  */
    isUserRoleSupervisorAndTimeOffEmployeeHourly(): boolean {
      return (
        (this.event.employee as IEmployee).isHourly && this.isUserSupervisor
      );
    },

    employeeBookingBalance(): IEmployeeTimeOffBookingBalance | undefined {
      const balance = this.employeeTimeOffBalances.find(
        (data: IEmployeeTimeOffBookingBalance) =>
          (data.employee_entitlement?.timeoff as ITimeOffTypeData).id ==
          (this.event.type! as ITimeOffTypeData).id
      );

      if (!balance) {
        return undefined;
      }

      return balance;
    },

    overdraftSupported(): boolean {
      let overdraftSupported = false;

      if (
        this.employeeBookingBalance &&
        this.employeeBookingBalance.employee_entitlement
      ) {
        overdraftSupported = this.employeeBookingBalance.employee_entitlement
          .is_overdraft_supported!;
      }

      return overdraftSupported;
    }
  },

  methods: {
    ...mapActions({
      downloadTimeOffAttachment: 'timeOffRequest/downloadTimeOffAttachment'
    }),

    moment,

    startCase,

    showEndDate(event: ITimeOffRequest): boolean {
      return !moment(event.start).isSame(moment(event.end), 'date');
    },

    showTime(event: ITimeOffRequest): boolean {
      return event.type_requested == TimeOffRequestAmountTypes.Custom;
    },

    genEventPartialText(requested_subtype: PartialOptions): string {
      return requested_subtype == PartialOptions.PM
        ? 'Last part of the day'
        : 'First part of the day';
    },

    open() {
      this.$emit('open', this.event);
    },
    close() {
      this.$forceUpdate();
      this.$emit('close');
    },

    downloadAttachment(attachment: ITimeOffAttachment) {
      this.clearAllErrors();

      this.downloadTimeOffAttachment({
        id: this.event.id,
        attachmentId: attachment.id
      })
        .then(data => {
          createFile(data, attachment.filename!);
        })
        .then(() => {
          this.createSnack({
            color: 'success darken-1',
            type: 'download',
            right: true,
            useBtn: false,
            msg: `Downloaded file: '${attachment.filename}'`,
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        });
    },

    rebuild() {
      this.$emit('rebuild');
      this.close();
    },

    clearAllErrors() {
      this.errorMessage = '';
    },

    setErrorMessage({
      errorMessage,
      errorMessageDetail
    }: {
      errorMessage: string;
      errorMessageDetail: string;
    }) {
      this.errorMessage = errorMessage;
      this.errorMessageDetail = errorMessageDetail;
    }
  }
});
